import { Spin, Typography } from "antd";
import type React from "react";
import { getRelativeTime } from "@/utils/date";
import type { ConversationSummary } from "../assistant-types";

interface RecentConversationsProps {
  /** Undefined while loading. */
  recent: ConversationSummary[] | undefined;
  onResume: (conversationId: string) => void;
}

const questionsLabel = (count: number): string =>
  count === 1 ? "1 question" : `${count} questions`;

/** The Caller's latest Conversations, newest first; picking one resumes it. */
export const RecentConversations: React.FC<RecentConversationsProps> = ({ recent, onResume }) => {
  if (recent === undefined) {
    return (
      <Spin size="small" tip="Loading your recent conversations…">
        <div className="h-8" />
      </Spin>
    );
  }
  if (recent.length === 0) return null;
  return (
    <div className="flex flex-col gap-2">
      <Typography.Text strong>Recent conversations</Typography.Text>
      {recent.map((conversation) => (
        <button
          key={conversation.conversationId}
          type="button"
          className="flex flex-col items-start rounded-lg border px-3 py-2 text-left hover:bg-gray-50"
          onClick={() => onResume(conversation.conversationId)}
        >
          <Typography.Text ellipsis className="w-full">
            {conversation.title}
          </Typography.Text>
          <Typography.Text type="secondary" className="text-xs">
            {getRelativeTime(conversation.lastActivityAt)} ·{" "}
            {questionsLabel(conversation.questionCount)}
          </Typography.Text>
        </button>
      ))}
    </div>
  );
};
